import ClipboardIcon from '@images/icons/clipboard.svg?react'
import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import { type MouseEvent, type ReactNode, useId } from 'react'
import ReactTooltip from 'react-tooltip'
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard'

import './CoreCopyButton.scss'

interface Props {
  value: string | number | null | undefined
  icon?: ReactNode
  className?: string
  dataTest?: string
}

export const CoreCopyButton = ({ value, icon, className, dataTest }: Props) => {
  const tooltipId = useId()
  const { copied, copy } = useCopyToClipboard()

  if (value === null || value === undefined || value === '') return null

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    copy(String(value))
  }

  return (
    <>
      <div className={cn('core-copy-button', className)} data-test={dataTest} data-for={tooltipId} onClick={handleClick}>
        {icon ?? <ClipboardIcon />}
      </div>
      <ReactTooltip
        id={tooltipId}
        content={tr('FRONTEND.GENERIC.COPIED', 'Copied')}
        isOpen={copied}
        imperativeModeOnly
        place='top'
        type='dark'
        class='copy-text-tooltip'
        padding='8px 10px'
      />
    </>
  )
}
